// PLUGINS IMPORTS //
import React from 'react'
import styled from 'styled-components/macro'
import { Icon } from 'Content/Shared/Components/Elements/index'

// COMPONENTS IMPORTS //
import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //
import { iPhoneResolution } from 'Content/Shared/Styles/Theme'

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  isTransparent?: boolean
}

const SocialMediaSection: React.FC<PropsType> = (props) => {
  return (
    <>
      <Row>
        <Icon
          link={'https://github.com/Artem711'}
          icon={'fab mdi fa-github'}
          isTransparent={props.isTransparent}
        />
        <Icon
          link={'https://twitter.com/Artem66063023'}
          icon={'fab fa-twitter'}
          isTransparent={props.isTransparent}
        />
        <Icon
          link={'https://www.youtube.com/channel/UC2Q2qLKUSXfPS_mxrtqvixA'}
          icon={'fab fa-youtube'}
          isTransparent={props.isTransparent}
        />
        <Icon
          link={'https://www.linkedin.com/in/artem77/'}
          icon={'fab mdi fa-linkedin'}
          isTransparent={props.isTransparent}
        />
      </Row>
    </>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export default React.memo(SocialMediaSection, memoComparison)
